export interface JwtConfig {
    loginEndpoint: string
    refreshEndpoint: string
    logoutEndpoint: string
    tokenType: string
    tokenExpireAt: string
    storageTokenKeyName: string
    storageRefreshTokenKeyName: string
    storageLanguageKeyName: string
    registerEndpoint?: string
    storageWebPushTokenName: string
}

export default {
    // Endpoints
    loginEndpoint: '/api/auth/login',
    // registerEndpoint: '/api/auth/register',
    refreshEndpoint: '/api/auth/refresh-token',
    logoutEndpoint: '/api/auth/logout',

    // This will be prefixed in authorization header with token
    // e.g. Authorization: Bearer <token>
    tokenType: 'Bearer',
    // Time that token expires (minutes)
    tokenExpireAt: 'expires_at',

    // Value of this property will be used as key to store JWT token in storage
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken',
    storageLanguageKeyName: 'language',

    // Web Pusk Token
    storageWebPushTokenName: 'webPushToken',
} as JwtConfig
